/* tslint:disable */
/* eslint-disable */
/**
 * fantasy-dynasty-app
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { NflSeason } from '../model';
/**
 * NflSeasonApi - axios parameter creator
 * @export
 */
export const NflSeasonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get All NFL Season Info in CAPSized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNflSeasons: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/nfl_seasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save an NFL Season\'s Info
         * @param {NflSeason} nflSeason 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveNflSeason: async (nflSeason: NflSeason, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nflSeason' is not null or undefined
            assertParamExists('saveNflSeason', 'nflSeason', nflSeason)
            const localVarPath = `/nfl_seasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nflSeason, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NflSeasonApi - functional programming interface
 * @export
 */
export const NflSeasonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NflSeasonApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get All NFL Season Info in CAPSized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllNflSeasons(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NflSeason>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllNflSeasons(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save an NFL Season\'s Info
         * @param {NflSeason} nflSeason 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveNflSeason(nflSeason: NflSeason, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NflSeason>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveNflSeason(nflSeason, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NflSeasonApi - factory interface
 * @export
 */
export const NflSeasonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NflSeasonApiFp(configuration)
    return {
        /**
         * 
         * @summary Get All NFL Season Info in CAPSized
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNflSeasons(options?: any): AxiosPromise<Array<NflSeason>> {
            return localVarFp.getAllNflSeasons(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save an NFL Season\'s Info
         * @param {NflSeason} nflSeason 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveNflSeason(nflSeason: NflSeason, options?: any): AxiosPromise<NflSeason> {
            return localVarFp.saveNflSeason(nflSeason, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NflSeasonApi - object-oriented interface
 * @export
 * @class NflSeasonApi
 * @extends {BaseAPI}
 */
export class NflSeasonApi extends BaseAPI {
    /**
     * 
     * @summary Get All NFL Season Info in CAPSized
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NflSeasonApi
     */
    public getAllNflSeasons(options?: AxiosRequestConfig) {
        return NflSeasonApiFp(this.configuration).getAllNflSeasons(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save an NFL Season\'s Info
     * @param {NflSeason} nflSeason 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NflSeasonApi
     */
    public saveNflSeason(nflSeason: NflSeason, options?: AxiosRequestConfig) {
        return NflSeasonApiFp(this.configuration).saveNflSeason(nflSeason, options).then((request) => request(this.axios, this.basePath));
    }
}
